module.exports = __webpack_public_path__ + "static/portfolio-mas-10-bbe1a1675b0f17442275e9c5ddcd0c56.jpg";